import styled from 'styled-components';
import { Box } from '@rsos/components/capstone/base';
import { withLayout } from '@rsos/components/capstone/base/Layout';

export const Wrapper = withLayout(styled(Box).attrs({
  bg: 'foreground',
  align: 'center',
  justify: 'center',
})`
  height: ${({ layout }) => layout.body.height}px;
`);

export const Content = styled(Box).attrs({
  align: 'center',
  width: 512,
  flow: 15,
})``;
export const StyledAnchor = styled.a`
  color: ${({ theme }) => theme.colors.primaryBase};
`;
